import { render } from "./paginator.vue?vue&type=template&id=9270501a&scoped=true"
import script from "./paginator.vue?vue&type=script&lang=js"
export * from "./paginator.vue?vue&type=script&lang=js"

import "./paginator.vue?vue&type=style&index=0&id=9270501a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3468298279/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9270501a"]])

export default __exports__